/**
 * 图表管理 Composable
 * 管理脑波图表的初始化、更新、清理等功能
 */

export default function useChartManager() {
  return {
    methods: {
      /**
       * 初始化所有脑波图表
       */
      initCharts() {
        const view = this.$refs.sleepView;
        if (view && view.initCharts) {
          view.initCharts();
        }
      },

      /**
       * 初始化单个脑波图表
       * @param {number} index - 图表索引
       * @param {Object} item - 预约数据项
       */
      initChart(index, item) {
        const view = this.$refs.sleepView;
        if (view && view.initChart) {
          view.initChart(index, item);
        }
      },

      /**
       * 获取图表配置选项（不生成虚拟数据）
       * @param {Object} item - 预约数据项
       * @returns {Object} 图表配置选项
       */
      getChartOption(item) {
        const view = this.$refs.sleepView;
        if (view && view.getChartOption) {
          return view.getChartOption(item);
        }
        return {};
      },

      /**
       * 更新所有图表
       */
      updateAllCharts() {
        const view = this.$refs.sleepView;
        if (view && view.updateAllCharts) {
          view.updateAllCharts();
        }
      },

      /**
       * 调整所有图表尺寸
       */
      resizeAllCharts() {
        const view = this.$refs.sleepView;
        if (view && view.resizeAllCharts) {
          view.resizeAllCharts();
        }
      },

      /**
       * 更新单个图表
       * @param {number} index - 图表索引
       * @param {Object} item - 预约数据项
       */
      updateChart(index, item) {
        const view = this.$refs.sleepView;
        if (view && view.updateChart) {
          view.updateChart(index, item);
        }
      },

      /**
       * 销毁所有图表
       */
      disposeCharts() {
        const view = this.$refs.sleepView;
        if (view && view.disposeAllCharts) {
          view.disposeAllCharts();
        }
        // 强制清理所有可能的Canvas元素
        this.forceCleanupAllCanvases();
      },

      /**
       * 强制清理所有Canvas元素
       */
      forceCleanupAllCanvases() {
        // 清理所有wave-chart相关的Canvas元素，无论是否在实例管理中
        const modulesWrapper = this.$refs.sleepView && this.$refs.sleepView.$refs.modulesWrapper;
        if (modulesWrapper) {
          // 查找所有echarts-container元素
          const chartContainers = modulesWrapper.querySelectorAll('.echarts-container');
          chartContainers.forEach(container => {
            // 清理容器内的所有Canvas
            const canvases = container.querySelectorAll('canvas');
            canvases.forEach(canvas => {
              try {
                canvas.remove();
              } catch (e) {
                // 忽略错误
              }
            });
            // 清空容器内容
            container.innerHTML = '';
          });
        }
        // 全局查找所有可能的wave-chart相关的Canvas（防止有遗漏）
        const allChartContainers = document.querySelectorAll('[id^="wave-chart-"]');
        allChartContainers.forEach(container => {
          const canvases = container.querySelectorAll('canvas');
          canvases.forEach(canvas => {
            try {
              canvas.remove();
            } catch (e) {
              // 忽略错误
            }
          });
          container.innerHTML = '';
        });
      }
    }
  };
}
